import React, { Component } from 'react';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Markdown from 'react-markdown';

import { actionCreators as toastActions } from '../../../redux/Toasts/actions';

import { toast } from '../../../utils/propTypes';

import styles from './styles.scss';

class Toast extends Component {
  static propTypes = {
    toast: toast.isRequired,
    addToast: PropTypes.func.isRequired,
    closeToast: PropTypes.func.isRequired,
    setToastTimeout: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const {
      toast: { id, duration },
      setToastTimeout,
    } = this.props;
    setToastTimeout(id, setTimeout(this.closeToast, duration));
  }

  componentWillUnmount() {
    const { toast: { timeout } } = this.props;
    if (typeof timeout === 'number') {
      clearTimeout(timeout);
    }
  }

  closeToast = () => {
    const {
      toast: { id, timeout },
      setToastTimeout,
      closeToast,
    } = this.props;
    if (typeof timeout === 'number') {
      clearTimeout(timeout);
    }
    setToastTimeout(id, null);
    closeToast(id);
  };

  render() {
    const {
      toast: { id, message, type }, addToast, closeToast, setToastTimeout, ...props
    } = this.props;
    return (
      <CSSTransition
        {...props}
        appear
        mountOnEnter
        unmountOnExit
        classNames={{
          appear: styles.appear,
          appearActive: styles.appearActive,
          enter: styles.appear,
          enterActive: styles.appearActive,
          exit: styles.exit,
          exitActive: styles.exitActive,
        }}
        timeout={200}
      >
        <div id={`toast-${id}`} className={classNames(styles.toast, styles[type])}>
          <div className={styles.header}>
            <Markdown source={message} skipHtml />
            <button type="button" className={styles.button} onClick={this.closeToast}>
              &times;
            </button>
          </div>
        </div>
      </CSSTransition>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(toastActions, dispatch);
}

export default connect(null, mapDispatchToProps)(Toast);



// WEBPACK FOOTER //
// ./src/app/components/Toast/index.js